const $ = require("jquery");

(function () {
    var benifyIframe = {
        onComplete: function onComplete(element, data) {
            $(element).find('button').prop('disabled', false);
            loadTable();
        }
    };
    application.benifyIframe = benifyIframe;

    function loadTable() {
        $('table').each(function () {
            var tableHead = $(this).find('thead');
            console.log("Här");
            if (tableHead.length > 0) {
                var headingsArr = [];
                $(this).find('th').each(function () {
                    var headings = $(this).text();
                    headingsArr.push(headings);
                })

                $(this).find('tr').each(function () {
                    $(this).find('td').each(function (i) {
                        $(this).attr('data-label', headingsArr[i]);
                    })
                })
            }
        });
    }
})(window, document, $, application = window.application || {});

